import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center flex-shrink-0" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-danger w-35px h-35px position-relative mx-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-bell-fill fs-2 pulse-danger rounded-circle" }),
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" })
], -1)
const _hoisted_4 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_5 = {
  class: "d-flex align-items-center",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"menu-icon border rounded-circle\"><span class=\"svg-icon svg-icon-3x\"><svg fill=\"none\" viewBox=\"0 0 18 18\" height=\"18\" width=\"18\" xmlns=\"http://www.w3.org/2000/svg\"><path xmlns=\"http://www.w3.org/2000/svg\" opacity=\"0.3\" d=\"M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z\" fill=\"currentColor\"></path><path xmlns=\"http://www.w3.org/2000/svg\" d=\"M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z\" fill=\"currentColor\"></path><rect xmlns=\"http://www.w3.org/2000/svg\" x=\"7\" y=\"6\" width=\"4\" height=\"4\" rx=\"2\" fill=\"currentColor\"></rect></svg></span></span>", 1)
const _hoisted_7 = { class: "zone-user ms-2" }
const _hoisted_8 = {
  key: 0,
  class: "d-block"
}
const _hoisted_9 = { class: "d-block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "vr d-none d-lg-flex h-40px mx-lg-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-cog ms-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_12 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_13 = {
  class: "btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_14 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Periodo = _resolveComponent("Periodo")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Periodo, { periods: _ctx.periods }, null, 8, ["periods"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_ctx.username?.abrev)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.username?.abrev), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.username?.firstname), 1)
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createVNode(_component_KTUserMenu)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/text/txt001.svg" })
        ])
      ])
    ])
  ]))
}